import React, { Component } from 'react';
import SettingsContainer from '../../../components/settings-container';
import workoutGroup from './img/workout-group.svg';
import './index.css';

export default class FitnessIntro extends Component {
  save() {}

  render() {
    return (
      <SettingsContainer
        className="fitness-intro-page"
        pageTitle="Now, let's personalize your fitness plan."
        isValid
      >
        <img src={ workoutGroup } alt="Workout group" />
      </SettingsContainer>
    );
  }
}
